// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b003db8c","355":"095d05e7","453":"25273358","455":"51c9eb1b","977":"49b163ae"}[chunkId] + ".chunk.js";
};